import React, { Component } from 'react';
import PropTypes from 'prop-types';

import includes from 'lodash/includes';

// Components
import { Container, Row, Col } from 'reactstrap';
import FullPageLayout from '../../../../components/FullPageLayout';
import CouponNotificationCard from '../../components/CampaignCards/CouponNotificationCard';
import {Campaign, CampaignPreviewCard} from 'dabbl-react-components'
import FinishedAllCampaignsMessage from '../../components/FinishedAllCampaignsMessage';
import LegalLinks from '../../../../components/LegalLinks';
import {RETAILER_NAME} from "../../../../retailerValues";
import { Alert, Button } from 'reactstrap';


// Images
import defaultFeedImage from '../../../../assets/images/feed-card-1.png';
import Promise from "bluebird";

class AvailableCampaignsList extends Component {

  static propTypes = {
    // Required
    campaigns: PropTypes.arrayOf(PropTypes.shape({
      brandName: PropTypes.string.isRequired,
      totalValue: PropTypes.number.isRequired,
      feedtext: PropTypes.string.isRequired,
      feedimageurl: PropTypes.string.isRequired,
    })),
    bufferAmount: PropTypes.number.isRequired,
    goalAmount: PropTypes.number.isRequired,
    // Optional
    onCardClick: PropTypes.func,
  }

  static defaultProps = {
    onCardClick: () => {},
  }

  constructor(props) {
    super(props);

    // this.state = {
    //   visibleAlert: !window.localStorage.getItem("OneDollarCouponAlertIsShown")
    // };

    // this.onDismissAlert = this.onDismissAlert.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if ((this.props.campaigns !== nextProps.campaigns) ||
      (this.props.cardAmount !== nextProps.cardAmount) ||
      (this.props.bufferAmount !== nextProps.bufferAmount) ||
      (this.props.goalAmount !== nextProps.goalAmount)) {
      return true
    }
    if (this.props.campaigns && nextProps.campaigns) {
      if (this.props.campaigns.length !== nextProps.campaigns.length) {
        return true
      }
      for (let i = 0; i < this.props.campaigns.length; i++) {
        if (this.props.campaigns[i].id !== nextProps.campaigns[i].id) {
          return true
        }
      }
    }
    // if (this.state.visibleAlert && !nextState.visibleAlert) {
    //   return true
    // }
    return false
  }

  // onDismissAlert() {
  //   window.localStorage.setItem("OneDollarCouponAlertIsShown", "true");
  //
  //   this.setState({ visibleAlert: false });
  // }

  getCouponAmount(bufferAmount) {
    if      (bufferAmount < 3)  return 1;
    else if (bufferAmount < 6)  return 3;
    else if (bufferAmount < 9)  return 6;
    else                        return 9;
  }

  handleAddClick(amt) {
    const { history } = this.props;
    history.push('/app/account');
  }

  handleWaitNextGoal(nextGoal) {
    this.props.setGoalAmount(nextGoal);
  }

  handleCampaignClick(campaignId) {
    this.props.onCardClick(campaignId);
  }

  render() {
    const {
      campaigns,
      cardAmount,
      bufferAmount,
      goalAmount,
      setDcmPreviewTagRendered,
      postCampaignCompletionAnswer
    } = this.props;

    const showBufferToLoyaltyCard = (cardAmount === 0 // no coupon
                                 && bufferAmount >= goalAmount); // have enough money
    const thereAreCampaigns = (
           campaigns
        && campaigns.length > 0
        // && campaigns[0].id
        // && campaigns[0].id.length > 0
    );
    return (
      <FullPageLayout>
        <Container className="AvailableCampaigns">
          {/*<Row>*/}
          {/*  <Alert color="warning" style={{width: '100%', textAlign: 'center'}}>*/}
          {/*    Downtime Dollars will experience a planned maintenance outage on Monday, June 1 from 2am - 6am EST. During this time, the application will be inaccessible. Thank you for your understanding.*/}
          {/*  </Alert>*/}
          {/*</Row>*/}
          {/*{ this.state.visibleAlert &&*/}
          {/*<Row>*/}
          {/*  <Alert color="warning" isOpen={this.state.visibleAlert} toggle={this.onDismissAlert} style={{width: '100%', textAlign: 'center'}}>*/}
          {/*    <p>*/}
          {/*      A new $1 coupon tier has been added to Downtime Dollars, allowing you to clip and save using Downtime Dollars earnings even faster!*/}
          {/*    </p>*/}
          {/*    <Button color="primary" onClick={this.onDismissAlert}>  Got it  </Button>*/}
          {/*  </Alert>*/}
          {/*</Row>*/}
          {/*}*/}
          <Row>
            {showBufferToLoyaltyCard && (
              <Col
                xs={{size: 10, offset: 1}}
                sm={{size: 8, offset: 2}}
                md={{size: 6, offset: 0}}
                lg={{size: 4, offset: 0}}
                xl={{size: 3, offset: 0}}
              >
                <CouponNotificationCard
                  couponAmount={this.getCouponAmount(bufferAmount)}
                  onAddClick={(amt) => this.handleAddClick(amt)}
                  onWaitClick={(nextGoal) => this.handleWaitNextGoal(nextGoal)}
                />
              </Col>
            )}
            {thereAreCampaigns && campaigns.map((c,i) => {
              //USE LODASH INCLUDES FOR COMPAT REASONS
              const tags = includes(this.props.dcm.renderedPreviewDcmTags,c.id) ? [] : c.tags
                setDcmPreviewTagRendered(c.id)
              return (
              <Col
                key={c.id}
                xs={{size: 10, offset: 1}}
                sm={{size: 8, offset: 2}}
                md={{size: 6, offset: 0}}
                lg={{size: 4, offset: 0}}
                xl={{size: 3, offset: 0}}
              >
                <CampaignPreviewCard
                    retailerName={RETAILER_NAME}
                  brandName={c.brandName}
                  brandColor={c.brandColor}
                  totalValue={c.totalValue}
                  text={c.feedtext}
                  tags={tags}
                  imgSrc={c.feedimageurl || defaultFeedImage}
                  imgAlt={c.brandName}
                  isCompleted={c.campaignComplete}
                  onClick={() => this.handleCampaignClick(c.id)}
                />
              </Col>
            )
            }
            )}


            {(!showBufferToLoyaltyCard && !thereAreCampaigns) && (
              <FinishedAllCampaignsMessage />
            )}


          </Row>
        </Container>

        <LegalLinks className="AvailableCampaigns_legalLinks" />

      </FullPageLayout>
    );
  }
}

export default AvailableCampaignsList;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/containers/AvailableCampaigns/AvailableCampaigns.js